module.exports = "//static.hsappstatic.net/marketplace-unified-public-base/static-1.1085/img/screenshot-twitter.png"